import quickFetch from 'quick-fetch';
import { COOKIE_ECHO_USER } from '../constants/EarlyRequesterNames';
export { getIsQA } from 'pricing-pages-ui-components/utils/envUtils';

/**
 * Returns true when running inside a Selenium acceptance-test session.
 * Copied from pricing-pages-ui/utils/testUtils — do not import from there.
 */
export const getIsAcceptanceTest = (webdriver = window.navigator.webdriver) => !!webdriver;

/* True when the COOKIE_ECHO_USER response carries a @hubspot.com email.
 * Shared by getIsHubSpotterSync and the useIsOverrideLocaleActive hook. */
export const isHubSpotEmailResponse = response => {
  if (typeof response !== 'object' || response === null || !('email' in response)) {
    return false;
  }
  const {
    email
  } = response;
  return typeof email === 'string' && email.endsWith('@hubspot.com');
};

/* Synchronously reads the resolved COOKIE_ECHO_USER early request.
 * Returns true if the user has a @hubspot.com email. whenFinished fires
 * immediately if the request already resolved; if still pending, returns false. */
export const getIsHubSpotterSync = () => {
  var _quickFetch$getReques;
  let result = false;
  (_quickFetch$getReques = quickFetch.getRequestStateByName(COOKIE_ECHO_USER)) === null || _quickFetch$getReques === void 0 || _quickFetch$getReques.whenFinished(response => {
    result = isHubSpotEmailResponse(response);
  });
  return result;
};